










































































































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import CompanySideCard from "@/components/company/CompanySideCard.vue";
import PdfViewer from "@/components/files/v2/PdfViewer.vue";
import SharedContentSideCard from "@/components/partner/SharedContentSideCard.vue";
import PersonSideCard from "@/components/person/PersonSideCard.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import CopyClipboardText from "@/components/utility/CopyClipboardText.vue";
import Debug from "@/components/utility/Debug.vue";
import MActionList from "@/components/utility/mmmint/MActionList.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IChips } from "@/components/utility/mmmint/MHeader.vue";
import RefsInvoiceParty from "@/components/utility/RefsInvoiceParty.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import { getFlagEmoji, getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { RepairEstimateGoToHelper } from "@/lib/utility/repair-estimate.go-to-helper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { Company, ICompany } from "@/models/company.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { RefsMessagesModule, RefTypeMap } from "@/store/modules/refs.store";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    MActionList,
    ConfirmActionDialog,
    Debug,
    CopyClipboardText,
    RefsSelect,
    PdfViewer,
    SharedContentSideCard,
    LatestEntriesCardEmpty,
    RefsInvoiceParty,
    PersonSideCard,
    CompanySideCard
  },
  filters: {
    getFlagEmojiByLanguage,
    getFlagEmoji
  }
})
export default class RepairEstimateDetail extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly RefsTypeMap = RefTypeMap;
  readonly RepairEstimate = RepairEstimate;
  readonly Address = Address;
  readonly formable = RepairEstimate;
  readonly DefaultTab = 0;
  readonly RefTypeMap = RefTypeMap;

  personSideCard: IPerson | null = null;

  companySideCard: ICompany | null = null;

  @Prop()
  value!: IRepairEstimate;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  isLoadingRefs = false;

  isAcceptDialog = false;

  isRepairEstimateAcceptDialogLoading = false;

  document: ISignDocument | null = null;

  isDocumentLoading = false;

  sharedContent: ISharedContent[] = [];

  selectedSharedContent: ISharedContent | null = null;

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "createdReadable",
      text: this.value.timestamp.createdReadable
    });

    chips.push({
      text: $t(`enums.RepairEstimateStatusEnum.${this.value.status}`),
      color: this.value.statusColor,
      key: "updatedReadable"
    });

    if (this.value.total) {
      chips.push({
        text: this.value.totalReadable,
        color: "success",
        key: "currency"
      });
    }

    return chips;
  }

  get sharedContentFilters() {
    return [
      new PageFilterElement({
        key: "refs.refId",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.value.id
      })
    ];
  }

  get refsCategories(): BackendResourceEnum[] {
    return [BackendResourceEnum.REPORT];
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = RepairEstimateGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.RepairEstimateTable(this.value.partnerId));
    selected.push(breadCrumbs.RepairEstimateDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new RepairEstimateGoToHelper(this.$router).goToRepairEstimateDetail({
            partnerId: this.value.partnerId,
            repairEstimateId: this.value.id,
            newTab: false
          })
      });
    }

    return actions;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new RepairEstimateGoToHelper(this.$router).goToRepairEstimateDetail({
            partnerId: this.value.partnerId,
            repairEstimateId: this.value.id,
            newTab: false
          })
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.REPAIR_ESTIMATE)) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.REPAIR_ESTIMATE
    };
  }

  async mounted() {
    await this.setDocument();
    await this.getSharedContent();

    RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
      refId: this.value.id,
      partnerId: this.value.partnerId
    });
  }

  async setDocument() {
    if (this.value.documentId) {
      this.isDocumentLoading = true;
      try {
        let document = DocumentModule.maps.id.get(this.value.documentId)[0];
        if (!document) {
          document = await new SignDocument({ partnerId: this.value.partnerId, id: this.value.documentId }).fetch();
        }
        this.document = document;
      } catch (e) {
        handleError(e);
      }
      this.isDocumentLoading = false;
    }
  }

  async getSharedContent() {
    SharedContentModule.setFilters(this.sharedContentFilters);
    await SharedContentModule.fetchFirstPage({ partnerId: this.value.partnerId });
    const elements = SharedContentModule.filteredAndSorted;
    this.sharedContent.splice(0);
    this.sharedContent.push(...elements.filter(e => e.refs.find(r => r.refId === this.value.id)));
    SharedContentModule.setFilters([]);
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  async acceptRepairEstimate() {
    // TODO: add dedicated mapping to RepairEstimate or a "accept" method to RepairEstimate. Better yet: add a backend route with status "Accepted"
    this.isRepairEstimateAcceptDialogLoading = true;
    await new RepairEstimate({})
      .map((this.value as unknown) as IRepairEstimate)
      .create()
      .then(d => {
        this.$toast.success("👍");
        d.goTo(this.$router).detail();
      })
      .catch(handleError)
      .finally(() => {
        this.isRepairEstimateAcceptDialogLoading = false;
      });
  }

  openBuyerSellerSideCard(ref?: IReference) {
    if (!ref) {
      return;
    }

    if (ref.refType === ResourceEnum.PERSON) {
      const element = new Person({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.personSideCard = element;
    } else if (ref.refType === ResourceEnum.COMPANY) {
      const element = new Company({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.companySideCard = element;
    }
  }
}
